export const API_URL = process.env.REACT_APP_API || "http://localhost:9000";
export const CONF = process.env.REACT_APP_CONF || "14mkpta";
export const SESSIONS =
  process.env.REACT_APP_SESSIONS || "A,B,C,D,E,F,G,H,I,J,K,L,X";
